<script setup>
import UserAvatar from "@/Components/users/UserAvatar.vue";

const props = defineProps({
    users: {
        type: Array,
        required: true,
    },
    status: {
        type: String,
        default: ''
    },
    size: {
        type: String,
        default: 'sm',
    },
    createLink: Boolean,
});

const createLink = (user) => user?.permissions?.view && props.createLink;
</script>

<template>
    <div v-if="users.length > 0" class="relative">
        <UserAvatar v-if="users.length === 1"
                    :id="createLink(users[0]) ? users[0].id : ''"
                    :avatar="users[0].avatar"
                    :size="size"
                    :badge="status ? `status-${status}` : ''"/>
        <div v-else>
            <UserAvatar :id="createLink(users[0]) ? users[0].id : ''"
                        class="-mt-1/4"
                        :avatar="users[0].avatar"
                        :size="size"
                        :badge="status ? `status-${status}` : ''"/>
            <template v-if="users.length === 2">
                <UserAvatar :id="createLink(users[1]) ? users[1].id : ''"
                            class="-mt-1/2 -mb-1/4"
                            :size="size"
                            :avatar="users[1].avatar"/>
            </template>
            <template v-else>
                <UserAvatar class="-mt-1/2 -mb-1/4"
                            :size="size"
                            :avatar="`https://ui-avatars.com/api/?format=svg&color=f0f0f0&name=${users.length > 10 ? '9%2B' : String(users.length - 1)}&background=7D7B83&format=svg`"
                />
            </template>
        </div>
    </div>
</template>
